import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6djj84hu7k: FaireBrandEntity = {
  token: "b_6djj84hu7k",
  type: "brand",
  name: "PERUVIAN PERFECTION",
  avatarUrl:
    "https://cdn.faire.com/fastly/ab78294e4a29b23c7fd49e6a8006d6de5668f5b5dd8331e3729c2b5779b61260.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/239a89563317392db93fa161c5428120e676ca0a6b6d75510eb56d1478df52e7.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ab78294e4a29b23c7fd49e6a8006d6de5668f5b5dd8331e3729c2b5779b61260.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/239a89563317392db93fa161c5428120e676ca0a6b6d75510eb56d1478df52e7.jpeg",
  location: "Palm Coast, FL, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 10,
  isTopShop: true,
  isInsider: true,
  description:
    "Peruvian Perfection was established in January 2002 as a family-owned company with a clear mission: to offer the finest alpaca garments in the market at highly competitive prices.\n\nWe work exclusively with top-grade alpaca fiber, recognized as some of the highest quality available today. Through decades of experience and direct relationships in Peru, we have refined our production process, allowing us to deliver exceptional quality, consistent craftsmanship, and outstanding value to our retail partners.\n\nAll Peruvian Perfection designs are exclusive and created by Katina, blending traditional Peruvian craftsmanship with refined, market-driven design. Each garment reflects originality, superior construction, and timeless elegance, making our collections instantly recognizable and trusted by retailers.\n\nBy working directly with skilled artisans throughout Peru and eliminating intermediaries, we ensure fair compensation, ethical production, and strict quality control from fiber selection to the finished piece.\n\nWith over 24 years of experience, Peruvian Perfection is recognized as one of the leading companies producing high-quality alpaca garments, proudly carried by both large and small retailers.\n\nWe sincerely thank our customers, partners, and artisans for over two decades of success and trust in our products. Your continued support has been essential to the growth and achievements of Peruvian Perfection.",
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:28:13.824Z",
    importedBy: "entity-db-cli",
  },
};
